import firebase from 'firebase/app';
import moment from 'moment'
import 'firebase/functions';

export default {
  namespaced: true,
  state: {
    searching: false,
    saving: false,
    searchResults: []
  },
  mutations: {
    setSearchResults(state, payload) {
      state.searchResults = payload
    },
    setSearching(state, payload) {
      state.searching = payload
    },
    setSaving(state, payload) {
      state.saving = payload
    }
  },
  actions: {
    search({commit}, payload) {
      commit('setSearching', true);
      var foodSearch = firebase.functions().httpsCallable('foodSearchSql');
      return foodSearch(payload.term)
      .then(function(result) {
        commit('setSearchResults', result ? result.data : [])
      })
      .catch(e => console.error(e))
      .finally(() => commit('setSearching', false))
    },  
    saveFood({commit, rootState}, payload) {
      commit('setSaving', true);
      let newFood = []

      // Step through each food
      payload.forEach(food => {
        // Change portion to weight
        if (food.Used.u == 'Portion') {
          food.q = food.p * food.Used.q;
        } else {
          food.q = food.Used.q;
        }
        // Split off into different meals
        // [    
        //   ['BREAKFAST', 0],
        //   ['LUNCH', 1],
        //   ['DINNER', 2],
        //   ['SNACKS', 3]
        // ]
        food.Used.m.forEach(meal => {
          const portion = JSON.parse(JSON.stringify(food)); // Deep copy
          switch (meal.toUpperCase()) {
            case 'BREAKFAST': portion.m = 0;
              break;
            case 'LUNCH': portion.m = 1;
              break;
            case 'DINNER': portion.m = 2;
              break;
            case 'SNACK': portion.m = 3;
              break;
          }
          newFood.push(portion)
        });
      });

      // Remove all Used objects
      newFood.forEach(food => {
        delete food.Used
      });

      // Add the existing food diary to it (Firebase hack)
      newFood.concat(rootState.Diary.foodDiary)

      // Save 
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      const dayId = moment(rootState.Diary.activeDate).format('YYYY-MM-DD');
      return profileDoc.collection('FoodDiary').doc(dayId).set({
        f: newFood,
        c: new Date()
      }).finally(() => commit('setSaving', false))
    }
  },
  getters: {
  }
}